<div fxLayout="column" class="w-100 h-100 p-10" (click)="$event.stopPropagation()">
  <!-- Upload -->
  <button class="upload-button" color="accent" mat-stroked-button type="submit" (click)="newReferenceInput.click()">
    <mat-icon>add</mat-icon>Upload Logo
    <input #newReferenceInput class="upload-input" type="file" (change)="onFileChosen($event?.target?.files)"
      onclick="value = null" [accept]="acceptedTypes.join(',')">
  </button>
  <button *ngIf="uri" class="upload-button" color="warn" mat-stroked-button type="submit" (click)="onSelection(null)">
    <mat-icon>cancel</mat-icon> Clear
  </button>
  <mat-list fxLayout="column" fxLayoutGap="10px">
    <ng-container *ngFor="let logo of logos">
      <div fxLayout="row" class="w-100 mat-list-item" fxLayoutGap="5px" fxLayoutAlign="space-between center">
        <img [src]="logo.uri" (click)="onSelection(logo)">
        <button mat-icon-button (click)="onRemove(logo)" color="accent" matTooltip="Remove File">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </ng-container>
    </mat-list>
  </div>